export default __webpack_public_path__ + "static/media/gm-pp-girl.dd6c84e3.webp";